module.exports = __webpack_public_path__ + "img/audio-play2.45cc7837.png";